import axios from 'axios';
import cookieLocalStorage from '../helpers/dataStorage';
import router from '@/router';
import AWS from '@/resources/AWS.js';

import {toastr} from '@/main';

const urlSearchParams = new URLSearchParams(window.location.search);
const params = Object.fromEntries(urlSearchParams.entries());
const prodDomain = process.env.VUE_APP_LOCAL_PROD_URL ? process.env.VUE_APP_LOCAL_PROD_URL : process.env.VUE_APP_PROD_URL;
const stageDomain = process.env.VUE_APP_LOCAL_STAGE_URL ? process.env.VUE_APP_LOCAL_STAGE_URL : process.env.VUE_APP_STAGE_URL;
const isStage = localStorage.getItem('lastPageIsStage') ? localStorage.getItem('lastPageIsStage') === 'true' : params.staging === 'true';
const currentDomain = isStage ? stageDomain : prodDomain;

export default {
    jsonp: function (url) {
        return new Promise(function (resolve) {
            let script = document.createElement('script');
            const name = '_jsonp_' + Math.round(1000000000000 * Math.random());
            //url formatting
            if (url.match(/\?/)) url += '&callback=' + name;
            else url += '?callback=' + name;
            script.src = url;

            window[name] = function (data) {
                resolve(data);
                document.body.removeChild(script);
                delete window[name];
            };
            document.body.appendChild(script);
        });
    },
    httpCustomRequest: function (url, body = {}, method = 'get') {
        return axios[method](url, body);
    },
    httpRequest: function (url, body = {}, method = 'get', config = {}) {
        axios.defaults.headers.common['Authorization'] = `Bearer ${cookieLocalStorage.get('access_token')}`;

        if (method.toLowerCase() !== 'delete') {
            return axios[method](`${currentDomain}/${url}`, body, config).then((resolve) => {
                localStorage.removeItem('lastPageIsStage');
                return this.emptyPromise(resolve);
            }).catch((error) => {
                // return this.emptyPromise(error);
                if (axios.isCancel(error)) {
                    return this.emptyPromise(error);
                }
                if (error.response.status === 401 && window.location.pathname !== '/signedin' && window.location.pathname !== '/demo' && window.location.pathname !== '/login' && window.location.pathname !== '/cli-callback') {
                    const params = Object.fromEntries(new URLSearchParams(window.location.search).entries());
                    const originalRequest = error.config;
                    localStorage.setItem('lastPage', window.location.pathname + window.location.search);
                    if (params.staging) {
                        localStorage.setItem('lastPageIsStage', params.staging);
                    }
                    const URItoReturn = router.currentRoute.fullPath;
                    return AWS.validateTokens(URItoReturn).then(() => {
                        originalRequest.headers['Authorization'] = `Bearer ${cookieLocalStorage.get('access_token')}`;
                        return Promise.resolve(axios(originalRequest)).then((response) => {
                            // console.log('response', _.cloneDeep(response));
                            return this.emptyPromise(response);
                        });
                    })
                        .catch(() => {
                            toastr().longError(
                                'Unauthorized',
                            );
                        });

                    // localStorage.setItem('lastPage', window.location.pathname + window.location.search);
                    // window.location.pathname = '/signedin';
                } else {
                    return this.emptyPromise(error, false);
                }
            });
        }

        return axios[method](`${currentDomain}/${url}`, {data: body}, config);
    },
    emptyPromise(data, isResolve = true) {
        return new Promise((resolve, reject) => {
            if (isResolve) {
                resolve(data);
            } else {
                reject(data);
            }
        });
    },
    getCancelTokenSource() {
        const CancelToken = axios.CancelToken;
        return CancelToken.source();
    },
};
